import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import environment from 'environments/environment';
import rootReducer from './reducers/root.reducer';
import rootSaga from './sagas/root.saga';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
	rootReducer,
	environment.prod
		? applyMiddleware(sagaMiddleware)
		: composeWithDevTools(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(rootSaga);
export type RootState = ReturnType<typeof store.getState>;
export default store;
